import { useRef } from "react";
import { useBaseRecorder } from "./useBaseRecorder";

export const useConversationRecorder = ({ onStatusChange } = {}) => {
  const { startBaseRecording, stopBaseRecording, cleanup } = useBaseRecorder({ onStatusChange });
  const recorderRef = useRef(null);
  
  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const { recorder } = await startBaseRecording(stream); // stream 전달
      recorderRef.current = recorder;
      onStatusChange?.("recording");
    } catch (err) {
      console.error(err);
      alert("브라우저 설정에서 마이크 접근을 허용한 후 다시 시도해주세요.");
      onStatusChange?.("error");
    }
  };

  const pauseRecording = () => {
    recorderRef.current?.pause?.();
    onStatusChange?.("paused");
  };

  const resumeRecording = () => {
    recorderRef.current?.resume?.();
    onStatusChange?.("recording");
  };

  const stopRecording = async () => {
    if (!recorderRef.current) return null;
    
    try {
      const blob = await stopBaseRecording();
      recorderRef.current = null;

      if (!blob) {
      onStatusChange?.("error");
      return null;
     }

    //  onStatusChange?.("idle");
     return blob;

    } catch (err) {
      console.log("녹음 실패", err)
      onStatusChange?.("error");
    } finally {
      cleanup();
    }
  };

  const resetRecording = () => {
    cleanup();
    recorderRef.current = null;
    onStatusChange?.("idle");
  };

  

  return { startRecording, pauseRecording, resumeRecording, stopRecording, resetRecording};
};
